export default {"src":"/_next/static/media/trash.c687e491.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};